import React from 'react';
import HomeHeroAuthentication from '@/pages/home/hero/HomeHeroAuthentication';
import { cdnImage } from '@/utils/image-utils';
import { openModal } from '@/store/actions/modal';
import { useDispatch } from 'react-redux';

const HomeHeroContentPublicThailand = (): JSX.Element => {
  const dispatch = useDispatch();

  const handleOpenLineChat = () => {
    dispatch(openModal('lineChat'));
  };

  return (
    <div>
      <HomeHeroAuthentication />
      <div className="absolute bottom-8 right-8 cursor-pointer" onClick={handleOpenLineChat}>
        <img
          className="hidden md:block"
          width="200px"
          src={cdnImage('line-chat-cat.png', {
            width: '200',
            height: 'auto',
            fit: 'contain',
          })}
          alt="Line chat"
        />
        <img
          className="block md:hidden w-10"
          alt="LINE Chat"
          src={cdnImage('line-app.png', {
            width: '48',
            height: '48',
            fit: 'contain',
            dpr: '2',
          })}
        />
      </div>
    </div>
  );
};

export default HomeHeroContentPublicThailand;
